import { API_ROUTES } from '@/constants/apiRoutes';
import { client } from '../client/client';

export function getPreSignedUrl(keyName: string) {
  return client.get(`${API_ROUTES.GET_PRESIGNED_URL}?keyName=${keyName}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: null,
    },
  });
}
